// plugins/initialization.ts
import { useWebsiteStore } from '~/store/website'

export default defineNuxtPlugin(async (nuxtApp) => {
  const websiteStore = useWebsiteStore()

  // If not loaded, fetch once
  // if (!websiteStore.initializationData) {
  //   await websiteStore.fetchInitializationData()
  // }
})
